import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelConnectionTestFailedAction = {
	type: 'AI_MODEL_CONNECTION_TEST_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelConnectionTestFailedAction => ({
	type: 'AI_MODEL_CONNECTION_TEST_FAILED',
	payload,
});
